import type { IWarehouse } from '@nova/core';

export function isReferenceRequired(warehouse: Partial<IWarehouse>): boolean {
  return warehouse.settings?.gateManagementDriverReferenceRequired === true;
}

// Required wins over a stale "not collected" flag, since the details step enforces Required.
export function isReferenceNotCollected(warehouse: Partial<IWarehouse>): boolean {
  return (
    !isReferenceRequired(warehouse) &&
    warehouse.settings?.gateManagementUnsetDriversReferenceNumber === true
  );
}
